export default "__VITE_ASSET__CCnpBseO__"